import { TypographyV3 } from '@jouzen/ecom-components';
import { useTranslations } from 'next-intl';

import P from '../P';

const IpIntro = () => {
  const t = useTranslations();
  return (
    <>
      <TypographyV3 Element="h1" variant="h1" className="mb-16 pb-8">
        {t('ip_notice_title')}
      </TypographyV3>

      <P tx="ip_notice_intro" />
    </>
  );
};

export default IpIntro;
